// extracted by mini-css-extract-plugin
module.exports = {"table":"Customers_table__3vFTT"};